import Test from '@/page/Test.vue'
import login from '@/page/login.vue'
import message from '@/mobilePages/message.vue'
import index from '@/page/index.vue'
import hot from '@/page/hot.vue'
import Recharge from '@/mobilePages/credits.vue'
import userIndex from '@/page/user/index.vue'
import myhot from '@/page/user/myhot.vue'
// import userProfile from '@/page/user/profile.vue'
import changepwd from '@/page/user/changepwd.vue'
import NotFoundView from '@/page/404.vue'
import memberinfo from '@/mobilePages/user/memberinfo.vue'
import myphotos from '@/page/user/myphotos.vue'
import myvideos from '@/page/user/myvideos.vue'
import benefits from '@/page/credits/benefits.vue'
import mailbox from '@/page/mailbox.vue'
import maildetail from '@/page/mailbox/maildetail.vue'
import PaymentResult from '@/page/payment/result.vue'
import PeopleIndex from '@/page/people/Index.vue'
import ArticleDetail from '@/page/article/Detail.vue'
import PresentsList from '@/mobilePages/presents/List.vue'
import PhoneReserve from '@/page/presents/PhoneReserve.vue'
import PresentsCart from '@/mobilePages/presents/Cart.vue'
import OrdersGift from '@/page/orders/List.vue'
import OrdersPhone from '@/page/orders/PhoneOrders.vue'
import Mine from '@/page/user/Mine.vue'
import ChatVoiceChat from '@/page/chat/VoiceChat.vue'
import ChatVoiceChatRoom from '@/page/chat/VoiceChatRoom.vue'

export default [
    {
        path: '/test',
        component: Test,
        meta: {
            title: "Test",
            keepAlive: true
        }
    },
    {
        path: '/voicechat',
        component: ChatVoiceChat,
        meta: {
            title: "VoiceChat",
            keepAlive: true
        }
    },
    {
        path: '/voicechatroom',
        component: ChatVoiceChatRoom,
        meta: {
            title: "VoiceChatRoom",
            keepAlive: true
        }
    },
    {
        path: '/',
        component: index,
        meta: {
            title: "home",
            isShowHeader: true,
            keepAlive: true
        }
    },
    {
        path: '/login',
        component: login,
        meta: {
            title: "login",
            isShowHeader: true,
            keepAlive: false
        }
    },
    {
        path: '/message',
        component: message,
        meta: {
            title: 'message',
            isShowHeader: true,
            keepAlive: true

        },

    },
    {
        path: '/mailbox',
        component: mailbox,
        meta: {
            title: 'Mailbox',
            isShowHeader: true,
            keepAlive: true

        },
    },
    {
        path: '/maildetail/:id',
        component: maildetail,
        meta: {
            title: "maildetail",
            isShowHeader: false,
            keepAlive: true
        }
    },
    {
        path: '/hot',
        component: hot,
        meta: {
            title: 'hotTopic',
            isShowHeader: true,
            keepAlive: true

        },
    },
    {
        path: '/recharge',
        component: Recharge,
        meta: {
            title: 'Recharge',
            isShowHeader: true,
            keepAlive: true

        },
    },
    {
        path: '/benefits',
        component: benefits,
        meta: {
            title: 'Benefits',
            isShowHeader: true,
            keepAlive: true

        },
    },
    {
        path: '/user',
        component: userIndex,
        meta: {
            title: 'UserInformation',
            isShowHeader: true,
            keepAlive: true

        },
    },

    {
        path: '/user/myhot',
        component: myhot,
        meta: {
            title: 'UserInformation',
            isShowHeader: true,
            keepAlive: true

        }
    },
    {
        path: '/user/myphotos',
        component: myphotos,
        meta: {
            title: 'MyPhotos',
            isShowHeader: true,
            keepAlive: true

        }
    },
    {
        path: '/user/myvideos',
        component: myvideos,
        meta: {
            title: 'MyVideos',
            isShowHeader: true,
            keepAlive: true

        }
    },
    {
        path: '/user/changepwd',
        component: changepwd,
        meta: {
            title: 'ChangePassword',
            isShowHeader: true,
            keepAlive: true

        }
    },
    {
        path: '/memberinfo/:id',
        component: memberinfo,
        meta: {
            title: "memberinfo",
            isShowHeader: true,
            keepAlive: true
        }
    },
    {
        path: '/payment/result',
        component: PaymentResult,
        meta: {
            title: 'PaymentResult',
            isShowHeader: true,
            keepAlive: true
        }
    },
    {
        path: '/people',
        component: PeopleIndex,
        meta: {
            title: 'People',
            isShowHeader: true,
            keepAlive: true
        }
    },
    {
        path: '/article',
        component: ArticleDetail,
        meta: {
            title: 'Article',
            isShowHeader: true,
            keepAlive: true
        }
    },
    {
        path: '/presents',
        component: PresentsList,
        meta: {
            title: 'Presents',
            isShowHeader: false,
            keepAlive: true
        }
    },
    {
        path: '/presents/cart',
        component: PresentsCart,
        meta: {
            title: 'PresentsCart',
            isShowHeader: true,
            keepAlive: true
        }
    },
    {
        path: '/presents/phone',
        component: PhoneReserve,
        meta: {
            title: 'PhoneReserve',
            isShowHeader: true,
            keepAlive: true
        }
    },
    {
        path: '/orders',
        component: OrdersGift,
        meta: {
            title: 'OrdersGift',
            isShowHeader: true,
            keepAlive: true
        }
    },
    {
        path: '/orders/phone',
        component: OrdersPhone,
        meta: {
            title: 'OrdersPhone',
            isShowHeader: true,
            keepAlive: true
        }
    },
    {
        path: '/mine',
        component: Mine,
        meta: {
            title: 'Mine',
            isShowHeader: true,
            keepAlive: true
        }
    },
    {
        // not found handler
        path: '*',
        component: NotFoundView
    }
]